import { Link } from "react-router-dom";

// Final CTA band — Forest Green.
export const AtlasCtaBand = () => (
  <section data-testid="atlas-cta-band" className="bg-forest">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16 md:py-20 flex flex-col md:flex-row md:items-center md:justify-between gap-8">
      <h2 className="font-serif text-3xl md:text-4xl text-white">Not sure which route fits?</h2>
      <Link
        to="/contact"
        data-testid="atlas-cta-talk"
        className="shrink-0 inline-flex items-center justify-center font-sans text-xs tracking-[0.14em] uppercase font-bold px-8 py-4 bg-[#B85C38] text-white border border-[#B85C38] transition-colors duration-300 hover:bg-[#9c4a2c] hover:border-[#9c4a2c]"
      >
        Talk to us
      </Link>
    </div>
  </section>
);
